/*
 * This file is part of the Convergence API Server.
 *
 * (c) Convergence <https://convergence.finance/>
 */

import faEnvelope from "@fortawesome/fontawesome-free-solid/faEnvelope";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import SendMessageModal from "./SendMessageModal/SendMessageModal";

type Props = {
    className?;
    selectRecipients?;
    institution;
    deal;
};

type State = {
    showModal: boolean;
};
class SendMessageButton extends React.Component<Props, State> {
    // TS CODE CHANGE. MOVED TO STATIC PROP TYPES
    static propTypes = {
        institution: PropTypes.object.isRequired,
        deal: PropTypes.object,
        selectRecipients: PropTypes.bool
    };
    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        };
    }

    toggle = (event) => {
        event.preventDefault();
        this.setState(({ showModal }) => ({ showModal: !showModal }));
    };

    render() {
        const className = this.props.className
            ? this.props.className
            : "btn btn-sm btn-primary";

        return (
            <React.Fragment>
                {this.state.showModal && (
                    <SendMessageModal
                        institution={this.props.institution}
                        deal={this.props.deal}
                        toggle={this.toggle}
                        selectRecipients={this.props.selectRecipients || false}
                    />
                )}
                <button className={className} onClick={this.toggle}>
                    <FontAwesomeIcon
                        icon={faEnvelope as IconProp}
                        size={"1x"}
                    />{" "}
                    Send Message
                </button>
            </React.Fragment>
        );
    }
}

export default SendMessageButton;
